import { render } from "./OuterItem.vue?vue&type=template&id=1eaa8491&scoped=true&ts=true"
import script from "./OuterItem.vue?vue&type=script&lang=ts"
export * from "./OuterItem.vue?vue&type=script&lang=ts"

import "./OuterItem.vue?vue&type=style&index=0&id=1eaa8491&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eaa8491"]])

export default __exports__